const measurementId = process.env.REACT_APP_GA_ID;

let initialized = false;
let scriptPromise = null;

const validMeasurementId = (id) => /^G-[A-Z0-9]+$/i.test(id || "");

export const isGA4Ready = () => initialized && typeof window.gtag === "function";

export const loadGA4AfterConsent = () => {
  if (!validMeasurementId(measurementId)) return Promise.resolve(false);
  if (initialized) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve) => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };

    // Pas de page_view automatique : le routeur React les envoie manuellement.
    window.gtag("js", new Date());
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
    window.gtag("config", measurementId, {
      send_page_view: false,
      anonymize_ip: true,
    });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.onload = () => { initialized = true; resolve(true); };
    script.onerror = () => { scriptPromise = null; resolve(false); };
    document.head.appendChild(script);
  });

  return scriptPromise;
};

export const trackPageView = (location) => {
  if (!isGA4Ready()) return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${location.pathname}${location.search}${location.hash}`,
  });
};

export const trackEvent = (name, parameters = {}) => {
  if (!isGA4Ready()) return;
  window.gtag("event", name, parameters);
};
